import { useState, useEffect } from 'react';
import { basic, validationMessages } from '../../../config/validations';
import { useForm } from "react-hook-form";
import { Grid, TextField } from '@material-ui/core';
import CreateBack from '../../atoms/buttons/CreateBack';
import NextCancel from '../../atoms/buttons/NextCancel';
import NextPrevious from '../../atoms/buttons/NextPrevious';
import { handleSnackBar, setInnerScreenRender, invokePostService, setFocusElement, toggleRightDrawer, invokeGetService, setReRender } from '../../../store/global/actions';
import { useDispatch } from 'react-redux';
import TransactionSelector from "./TransactionSelector";
import DelegateSelector from "./DelegateSelector";
import CreatableSelectBox from '../../atoms/CreatableSelectBox/CreatableSelectBox';


export default function EditSimulation({ onClose, setTabActive, tabActive, element }) {

    const dispatch = useDispatch();
    const { register, handleSubmit, control, formState: { errors }, setValue, reset, setError } = useForm();
    const [simulationInfo, setSimulationInfo] = useState({ name: element.name, description: element.description });
    const [isUpdating, setIsUpdating] = useState(false);
    const [selectedTransactions, setSelectedTransactions] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [selectedDelegates, setSelectedDelegates] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [testCaseId, setTestCaseId] = useState('');
    const [currentScenraio, setCurrentScenario] = useState()
    const [currentSim, setCurrentSim] = useState()
    const [simulationsList, setSimulationsList] = useState([]);




    const messages = {
        ...validationMessages,
    }
    const fetchSimulationDetails = () => {
        setIsFetching(true);
        const simulation = dispatch(invokeGetService('getSimulationData', [element.id]));
        const blueprintTransactions = dispatch(invokeGetService('getAllTransaction', {}));
        Promise.all([simulation, blueprintTransactions]).then(([simulationResponse, transactionResponse]) => {
            if (simulationResponse.status == true) {
                reset({
                    name: simulationResponse?.data?.simulation.name,
                    description: simulationResponse?.data?.simulation?.description,
                    scenario: simulationResponse?.data?.simulation?.scenario
                });

                // Current scenario setting to the state, its using for cross check the scenario duplication
                setCurrentScenario(simulationResponse?.data?.simulation?.scenario)
                setCurrentSim(simulationResponse?.data?.simulation.name)

                const simulationTransactions = simulationResponse?.data?.simulationTransactions.filter(item => !item.parent_id).map(item => {
                    return { _id: item.transaction_id, simulationTransactionId: item._id, order: item.order };
                });
                simulationTransactions.sort((a, b) => a.order - b.order)
                setSelectedTransactions(simulationTransactions);
                const delegates = simulationResponse?.data?.simulation?.delegates.map(item => {
                    return { _id: item.id }
                });
                setSelectedDelegates(delegates);
                setTestCaseId(simulationResponse?.data?.simulation?.testcase_id)
            } else {
                if (simulationResponse?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setFocusElement({}));
                }
            }
            if (transactionResponse.status == true) {
                const filteredTransactions = transactionResponse.data?.filter(transaction => transaction.type == 7);
                setTransactions(filteredTransactions);
            }
            setIsFetching(false);
        });
    }

    const fetchSimulationList = async () => {
        const response = await dispatch(invokeGetService('listSimulations',{}));
        const data = response.data;
        const simList = [];
        if(data?.length > 0){
            data.forEach((item) => simList.push({title: item.name, inputValue: item.name}));
        }
        setSimulationsList(simList);
    }

    useEffect(() => {
        fetchSimulationDetails();
        fetchSimulationList();
    }, []);


    const onSimulationNext = async ({ name, description, scenario }) => {
        if(!name){
            setError('name',{
                types: 'error',
                message: 'Name field is required',
                shouldFocus: 'name'
            })
            return true
        }

        console.log({name, description, scenario});
        
        const response = await dispatch(invokePostService('checkScenarioExistence',{
            simulationName: name,
            scenario,
            oldScenario: currentScenraio,
            testcaseId: testCaseId
        }))

        if(response.status){
            if(response.data.isExist){
                dispatch(handleSnackBar({open: true,message: response.message, severity: "error"}));
                return false;
            }
        }

        setSimulationInfo({ name, description, scenario });
        setValue('name', name);
        setValue('description', description);
        setValue('scenario', scenario)
        reset({ name, description, scenario })
        setTabActive('transaction');
    }

    const onTransactionNext = () => {
        if (selectedTransactions.length < 1) {
            const validateError = document.getElementById("transaction-validation-error");
            if (validateError === null) {
                document.getElementById(`simulation[simulation][0][transaction]`)?.insertAdjacentHTML("afterend", `<p id="transaction-validation-error" class="text text-danger validation-error" >Please select transaction</p>`);
            }
            return;
        } else {
            const validateError = document.getElementById("transaction-validation-error");
            if (validateError) {
                validateError.remove();
            }
        }
        setTabActive('delegate');
    }

    const onTransactionBack = () => {
        setTabActive("simulationInfo");
    }

    const onDelegateBack = () => {
        setTabActive("transaction");
    }

    const onUpdate = () => {
        if (selectedDelegates.length < 1) {
            dispatch(handleSnackBar({ open: true, message: 'Must select delegate to create simulation', severity: 'error' }));
            return;
        }
        setIsUpdating(true);
        const simulation = {
            name: simulationInfo.name,
            description: simulationInfo.description,
            scenario: simulationInfo.scenario,
            transactions: selectedTransactions,
            delegates: selectedDelegates.map(delegate => delegate._id)
        };


        dispatch(invokePostService('updateSimulation', { simulation, previousSim:  currentSim }, [element.id, testCaseId])).then(response => {
            setIsUpdating(false);
            if (response.status && response.data !== null) {
                dispatch(setInnerScreenRender());
                dispatch(toggleRightDrawer());
                dispatch(setFocusElement({}));
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                dispatch(setReRender())
            } else {
                if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    setTabActive("simulationInfo");
                    response?.errors?.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                } else if (response?.message) {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
                }
            }
        });
    }

    console.log({errors});

    return (
        <Grid container direction={"row"} spacing={3}>

            {tabActive == 'simulationInfo' &&
                <>
                    <Grid item xs={12}>
                        {/* <TextField
                            name="name"
                            id="name"
                            autoFocus
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Name"}
                            variant="outlined"
                            placeholder={""}
                            inputRef={register({ ...basic })}
                            error={errors?.name ? true : false}
                            InputLabelProps={{ shrink: true }}
                            helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                        /> */}
                        <CreatableSelectBox 
                            optionList={simulationsList}
                            control={control}
                            name='name'
                            label='Name'
                            createButtonPrefix='Create new testcase'
                            required
                            errors={errors}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            name="scenario"
                            id="scenario"
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Scenario"}
                            variant="outlined"
                            placeholder={""}
                            inputRef={register({ ...basic })}
                            error={errors?.scenario ? true : false}
                            InputLabelProps={{ shrink: true }}
                            helperText={errors?.scenario ? errors?.scenario?.message ? errors.scenario.message : messages[errors?.scenario?.type] : ''}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            type={"text"}
                            fullWidth
                            multiline={true}
                            rows={4}
                            label={"Description"}
                            variant="outlined"
                            name="description"
                            inputRef={register({ required: false })}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </>
            }

            {tabActive == 'transaction' &&
                <Grid item xs={12} style={{ minHeight: "60vh" }}>
                    <TransactionSelector tabActive={tabActive} transactions={transactions} selectedTransactions={selectedTransactions} setSelectedTransactions={setSelectedTransactions} isFetching={isFetching} setIsFetching={setIsFetching} />
                </Grid>
            }
            {tabActive == 'delegate' &&
                <Grid item xs={12} style={{ minHeight: "60vh" }}>
                    <DelegateSelector selectedTransactions={selectedTransactions} isFetching={isFetching} setIsFetching={setIsFetching} setSelectedDelegates={setSelectedDelegates} selectedDelegates={selectedDelegates} />
                </Grid>
            }

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                {tabActive == 'simulationInfo' && <NextCancel onNext={handleSubmit(onSimulationNext)} onCancel={onClose} disableNext={isFetching} content={'Next'} />}
                {tabActive == 'transaction' && <NextPrevious onNext={onTransactionNext} onPrevious={onTransactionBack} nextDisable={isFetching} />}
                {tabActive == 'delegate' && <CreateBack onCreate={onUpdate} onBack={onDelegateBack} createDisable={isUpdating || isFetching} content={isUpdating ? 'Updating..' : 'Update'} />}
            </Grid>

        </Grid >
    )
}